import { removeDomain } from '@opten/url/remove-domain';
import { wrapFunction } from '@opten/common/wrap-function';
import { getScriptBySrc } from '../get-script-by-src';
import { createScript } from '../create-script';

(window as any).loadingScripts = (window as any).loadingScripts || [];

export function loadScript(src: string) {
	return new Promise(
		(resolve: (ev?: Event) => void, reject: (ev: ErrorEvent) => void) => {
			const script = getScriptBySrc(src);

			if (script) {
				if (
					(window as any).loadingScripts.indexOf(removeDomain(script.src)) !==
					-1
				) {
					script.onerror = wrapFunction(script.onerror, reject);
					script.onload = wrapFunction(script.onload, resolve);
				} else {
					resolve();
				}
			} else {
				const newScript = createScript(src);
				newScript.onerror = reject;
				newScript.onload = wrapFunction(newScript.onload, resolve);
				document.head.appendChild(newScript);
			}
		}
	);
}
